import './layout.scss';
import Vue from 'vue';
import VueTableOfContent from '@ui-common/vue-table-of-content';
import macc from '../../modules/MACC/macc';
import macci from '../../modules/MACCI/macci';
import mdtb from '../../modules/MDTB/mdtb';
import meda from '../../modules/MEDA/meda';
import meok from '../../modules/MEOK/meok';
import mevp from '../../modules/MEVP/mevp';
import mfsh from '../../modules/MFSH/mfsh.vue';
import mhap from '../../modules/MHAP/mhap.vue';
import mife from '../../modules/MIFE/mife';
import mint from '../../modules/MINT/mint.vue';
import mint2021 from '../../modules/MINT2021/mint2021.vue';
import mjbl from '../../modules/MJBL/mjbl.vue';
import mksz from '../../modules/MKSZ/mksz';
import moav from '../../modules/MOAV/moav';
import mrbt from '../../modules/MRBT/mrbt';
import mstb from '../../modules/MSTB/mstb';
import mtab from '../../modules/MTAB/mtab';
import mtabr from '../../modules/MTABR/mtabr';
import mtbl from '../../modules/MTBL/mtbl';
import mubt from '../../modules/MUBT/mubt';
import mslc from '../../modules/MSLC/mslc';
import masd from '../../modules/MASD/masd.vue';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueTab from '@ui-common/vue-tab';
import LottieAnimation from '../../common/components/lottie-animation/lottie-animation.vue';
import videoPreview from '../../common/components/video-preview/video-preview.vue';
import videoPlayer from '../../common/components/video-player/video-player.vue';
import rcoAccountPackageSelectorButton from '../../applications/rco-account-package-picker/rco-account-package-selector-button/rco-account-package-selector-button';
import announcementsSelect from '../../common/components/announcements-select/announcements-select.js';
import BranchAtmWidgetWrapper from '../../applications/branch-atm-widget-wrapper/branch-atm-widget-wrapper.vue';
import layoutBase from '../layout-base';
import sectionLayout from '../../common/elements/section-layouts/section-layout';

Vue.component('macc', macc);
Vue.component('macci', macci);
Vue.component('mslc', mslc);
Vue.component('mdtb', mdtb);
Vue.component('meok', meok);
Vue.component('mevp', mevp);
Vue.component('mint', mint);
Vue.component('mint2021', mint2021);
Vue.component('mjbl', mjbl);
Vue.component('mrbt', mrbt);
Vue.component('mstb', mstb);
Vue.component('mtab', mtab);
Vue.component('mtabr', mtabr);
Vue.component('mtbl', mtbl);
Vue.component('mubt', mubt);
Vue.component('meda', meda);
Vue.component('mfsh', mfsh);
Vue.component('mhap', mhap);
Vue.component('mife', mife);
Vue.component('mksz', mksz);
Vue.component('moav', moav);
Vue.component('masd', masd);
Vue.component('vue-checkbox', VueCheckbox);
Vue.component('vue-tab', VueTab);
Vue.component('lottie-animation', LottieAnimation);
Vue.component('video-player', videoPlayer);
Vue.component('video-preview', videoPreview);
Vue.component('rco-account-package-selector-button', rcoAccountPackageSelectorButton);
Vue.component('announcements-select', announcementsSelect);
Vue.component('branch-atm-widget-wrapper', BranchAtmWidgetWrapper);
Vue.component('section-tab', sectionLayout);
Vue.component('vue-table-of-content', VueTableOfContent);

/* eslint-disable no-new*/
new Vue({
	el: '[data-layout-id=AV9TE-app]',
	extends: layoutBase
});
/* eslint-enable*/
